<template>
  <section id="effects" class="section--pt-xlg">
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">EFFECTS</span><br><span class="Head__main_jp">効果と継続</span>
      </h2>
      <div class="Beginner__box_area">
        <div class="Beginner__box">
          <p class="_l-lg _mg-b20">
            マインドフルネスの効果については様々な研究が発表されていますが、効果を実感するためには一定期間の継続が不可欠です。<br><br>一般に「2ヶ月の継続で効果を実感できる」と研究によって明らかになっており、MELONユーザーへのアンケート調査でも、8週間の継続で85%もの方が効果を実感しています。
          </p>
          <p class="_mg-b40-30">
            <a href="https://www.the-melon.com/blog/blog/mindfulness-effective-3436/" class="Link__line" target="_blank">記事「マインドフルネスの効果について」</a>
          </p>
        </div>
        <div class="Beginner__box _mg-b40-30">
          <img src="assets/img/ph_beginner02.jpg" alt="">
        </div>
      </div>
      <section class="section--pt50">
        <h3 class="Head__blue">
          継続のポイント
        </h3>
        <p class="_l-lg _mg-b20">
          動画ではなく「リアルタイムでご参加」いただくと、適度な緊張感やモチベーションにより継続がしやすいです。
        </p>
        <div class="Line_shop_card_box">
          <a href="https://www.the-melon.com/stamp_card/" target="_blank"><img src="assets/img/ph_line-shop-card.png" alt="" class="Line_shop_card_img"></a>
        </div>
        <p class="_l-lg _mg-b20">
          また、クラス受講・MELON TV視聴でポイントが貯まり、ご利用料金の割引などの特典が受け取れる「MELONオンライン スタンプカード」というサービスもあるので、ぜひご活用ください！
        </p>
      </section>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Effects'
}
</script>
